/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { connect } from "react-redux";
import { signOut } from "redux/actions/Auth";

export const NavNome = ({ signOut, user, avisos = [], isMobile }) => {
	// Função para truncar o nome removendo sobrenomes do final até ter menos de 13 caracteres
	const truncateNameForMobile = (fullName) => {
		if (!isMobile || !fullName || fullName.length < 13) {
			return fullName;
		}

		const nameParts = fullName.trim().split(" ");

		// Se só tem um nome ou já é menor que 13 caracteres, retorna como está
		if (nameParts.length <= 1) {
			return fullName;
		}

		// Mantém sempre o primeiro nome e vai removendo sobrenomes do final
		let truncatedParts = [...nameParts];
		while (
			truncatedParts.length > 1 &&
			truncatedParts.join(" ").length >= 13
		) {
			truncatedParts.pop(); // Remove o último sobrenome
		}

		return truncatedParts.join(" ");
	};

	const displayName = truncateNameForMobile(user.name);

	const styles = {
		container: {
			display: "flex",
			flexDirection: "column",
			justifyContent: "center",
			flexGrow: 1,
			marginRight: 22,
		},
		nome: {
			fontSize: 16,
			lineHeight: 1,
			color: "#1E1E1E",
			marginBottom: isMobile ? 0 : 6,
			width: "max-content",
			maxWidth: isMobile ? 140 : 170,
		},
		role: {
			fontSize: isMobile ? 13 : 14,
			lineHeight: 1,
			color: "#B6B6B6",
		},
	};

	return (
		<div style={styles.container}>
			<div>
				<div style={styles.nome}>{displayName}</div>
			</div>
			<div style={{ display: isMobile ? "none" : "block" }}>
				<div style={styles.role}>{user.role}</div>
			</div>
		</div>
	);
};

const mapStateToProps = ({ user, menu }) => {
	return {
		user: { ...user },
		avisos: menu.avisos,
	};
};

export default connect(mapStateToProps, { signOut })(NavNome);
